<template>
  <div class="content">
    <h2>User Photo Gallery</h2>
    <form>
      <select @input="stringFind($event)" class="custom-select">
        <option value="rov1">ROV Alvin</option>
        <option value="rov2">ROV Bob</option>
        <option value="rov3">ROV Charlie</option>
      </select>
      &nbsp;&nbsp;
      <select @input="termFind($event)" id="termId" ref="termId" class="custom-select">
        <!-- <option value = ""></option> -->
        <option value="la">Latest</option>
        <option value="ye">Yesterday</option>
        <option value="la_we">Last Week</option>
        <option value="la_mon">Last Month</option>
      </select>
    </form>
    <div
      class="row"
      v-if="stringFiteredData.length > 0 && stringFilteredState == true"
    >
      <div
        class="col"
        v-for="(item, index) in stringFiteredData"
        :key="index"
        :id="index"
      >
        <div class="col" v-if="index < numForLoadmore">
          <router-link :to="{ name: 'ImageOne', params: { name: item.name } }">
            <img
              :src="`https://photos.teleportal.net/${item.name}`"
              class="img"
            />
          </router-link>
          <div v-if="(index + 1) % 4 == 0"><br /></div>
        </div>
      </div>
    </div>
    <button
      v-if="
        stringFiteredData.length > numForLoadmore && stringFilteredState == true
      "
      @click="loadMoreFunc(1)"
    >
      Load More
    </button>
    <button
      v-if="numForLoadmore > 21 && stringFilteredState == true"
      @click="lessMoreFunc(1)"
    >
      Back To Top
    </button>

    <div
      class="row"
      v-if="termFiteredData.length > 0 && termFiteredState == true"
    >
      <div
        class="col"
        v-for="(item, index) in termFiteredData"
        :key="index"
        :id="index"
      >
        <div class="col" v-if="index < numForLoadmoreTwo">
          <router-link :to="{ name: 'ImageOne', params: { name: item.name } }">
            <img
              :src="`https://photos.teleportal.net/${item.name}`"
              class="img"
            />
          </router-link>
          <div v-if="(index + 1) % 4 == 0"><br /></div>
        </div>
      </div>
    </div>
    <button
      v-if="
        termFiteredData.length > numForLoadmoreTwo && termFiteredState == true
      "
      @click="loadMoreFunc(2)"
    >
      Load More
    </button>
    <button
      v-if="numForLoadmoreTwo > 21 && termFiteredState == true"
      @click="lessMoreFunc(2)"
    >
      Back To Top
    </button>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ImageProcess",
  props: {},
  data() {
    return {
      data: [],
      stringFiteredData: [],
      termFiteredData: [],
      stringFilteredState: false,
      termFiteredState: false,
      numForLoadmore: 20,
      numForLoadmoreTwo: 20,
      seletedRovState: "rov1",
      selectedTermVal: "la"
    };
  },
  methods: {
    stringFind(e) {
      var filteredData = [];
      var stringOptionArr = ["rov1", "rov2", "rov3"];
      if (this.data && stringOptionArr.includes(e.target.value) == true) {
        filteredData = this.data.filter(item => {
          return item.name.includes(e.target.value) === true;
        });
        this.stringFiteredData = filteredData;
        this.stringFilteredState = true;
        this.termFiteredState = false;
        this.seletedRovState = e.target.value;
      }
      var formObj = this.$refs["termId"];
      var len;
      len = formObj.length;
      for (let i = 0; i < len; i++) {
        formObj.options[0].selected = true;
      }
    },
    termFind(e) {
      var selectedVal = e.target.value;
      var now = new Date();
      var nowY = now.getFullYear();
      var nowM = now.getMonth() + 1;
      var nowD = now.getDate();
      var filteredOption = {
        filteredData_2: [],
        filteringValue: ""
      };
      nowM = nowM >= 10 ? nowM : "0" + nowM;
      nowD = nowD >= 10 ? nowD : "0" + nowD;
      if (selectedVal == "la") {
        filteredOption.filteringValue =
          nowY.toString() + nowM.toString() + nowD.toString();
        if (this.data) {
          filteredOption.filteredData_2 = this.data.filter(item => {
            return item.name.includes(this.seletedRovState);
          });
          this.termFiteredData = filteredOption.filteredData_2;
          console.log(
            "The count  {" +
              this.seletedRovState +
              "}  is   " +
              this.termFiteredData.length
          );
        }
      } else if (selectedVal == "ye") {
        var today =
          nowY.toString() + nowM.toString() + nowD.toString() + "000000";
        if (this.data) {
          filteredOption.filteredData_2 = this.data.filter(item => {
            var lastValue, last_value_2;
            lastValue = item.name.replace(this.seletedRovState, "");
            last_value_2 = lastValue.replace(".png", "");
            if (item.name.includes(this.seletedRovState) == true) {
              return last_value_2 < parseInt(today);
            }
          });
          this.termFiteredData = filteredOption.filteredData_2;
        }
      } else if (selectedVal == "la_we") {
        var week = new Date(now.getTime() - 60 * 60 * 24 * 7 * 1000);
        var weekY = week.getFullYear();
        var weekM = week.getMonth() + 1;
        var weekD = week.getDate();
        var weekValue = "";
        weekM = weekM >= 10 ? weekM : "0" + weekM;
        weekD = weekD >= 10 ? weekD : "0" + weekD;
        weekValue =
          weekY.toString() + weekM.toString() + weekD.toString() + "000000";
        filteredOption.filteredData_2 = this.data.filter(item => {
          var lastValue, last_value_2;
          lastValue = item.name.replace(this.seletedRovState, "");
          last_value_2 = lastValue.replace(".png", "");
          if (item.name.includes(this.seletedRovState) == true) {
            return last_value_2 < parseInt(weekValue);
          }
        });
        this.termFiteredData = filteredOption.filteredData_2;
      } else if (selectedVal == "la_mon") {
        var month = new Date(now.getTime() - 60 * 60 * 24 * 30 * 1000);
        var monthY = month.getFullYear();
        var monthM = month.getMonth() + 1;
        var monthD = month.getDate();
        var monthValue = "";
        monthM = monthM >= 10 ? monthM : "0" + monthM;
        monthD = monthD >= 10 ? monthD : "0" + monthD;
        monthValue =
          monthY.toString() + monthM.toString() + monthD.toString() + "000000";
        if (this.data) {
          filteredOption.filteredData_2 = this.data.filter(item => {
            var lastValue, last_value_2;
            lastValue = item.name.replace(this.seletedRovState, "");
            last_value_2 = lastValue.replace(".png", "");
            if (item.name.includes(this.seletedRovState) == true) {
              return last_value_2 < parseInt(monthValue);
            }
          });
          this.termFiteredData = filteredOption.filteredData_2;
          this.termFiteredState = true;
          this.stringFilteredState = false;
        }
      } else {
        this.termFiteredData = [];
      }
      this.termFiteredState = true;
      this.stringFilteredState = false;
      this.selectedTermVal = e.target.value;
    },
    loadMoreFunc(p) {
      if (p == 1) {
        this.numForLoadmore += 20;
      } else {
        this.numForLoadmoreTwo += 20;
      }
    },
    lessMoreFunc(p) {
      if (p == 1) {
        this.numForLoadmore = 20;
      } else {
        this.numForLoadmoreTwo = 20;
      }
    },
    loadFunc() {
      var filteredData = [];
      if (this.data) {
        filteredData = this.data.filter(item => {
          return item.name.includes("rov1") === true;
        });
        this.stringFiteredData = filteredData;
        this.stringFilteredState = true;
        this.termFiteredState = false;
      }
    },
    urlFind() {
      var parser,
        xmlDoc,
        xmlDoc_2 = [],
        imgUrl = [],
        num = 0,
        imgUrl_2 = [],
        l;
      parser = new DOMParser();
      axios.get("https://photos.teleportal.net/").then(res => {
        var xml = res.data;
        xmlDoc = parser.parseFromString(xml, "text/html");
        xmlDoc_2 = xmlDoc.getElementsByTagName("a");
        for (var i = 0; i < xmlDoc_2.length; i++) {
          if (xmlDoc_2[i].href.includes("rov")) {
            imgUrl.push({
              id: num,
              name: xmlDoc_2[i].href.replace(
                "https://" + location.host + "/",
                ""
              )
            });
            num += 1;
          }
        }
        for (l = imgUrl.length - 1; l >= 0; l--) {
          imgUrl_2.push(imgUrl[l]);
        }

        this.data = imgUrl_2;
        this.loadFunc();
      });
    }
  },
  computed: {},
  created: function() {
    this.urlFind();
  }
};
</script>

<style scoped>

.custom-select {
  font-size: 1.0rem; 
  padding: 0.5rem 0.5rem; 
  width: 15vw; 
  border: 1px solid #ccc; 
  border-radius: 0.3125rem; 
}


.img {
  width: 100%;
  max-width: 100%;
  margin: 1vw;
}

.row {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.col {
  width: 100%;
  flex-basis: calc(100% / 3);
}

@media (max-width: 1200px) {
  .col {
    flex-basis: calc(100% / 2); /* For screens between 769px and 1024px, set 2 columns */
  }
}

@media (max-width: 1024px) {
  .col {
    flex-basis: 100%; /* For screens less than or equal to 768px wide, set 1 column */
  }
}

.content {
  text-align: center;
  color: #2c3e50;
  margin-top: 2vw;
  font-size: 1.3rem;
  text-align: center;
}

.button {
  margin: 10px; /* Add margin around the button for spacing */
  font-size: 1em;
  font-weight: 600;
  border-radius: 10px; /* Makes corners rounded */
  padding: 0.5rem 1rem; /* Adjust padding to make the button look balanced */
}

</style>
